/**
 * Auto-generated Atom and Entity Infos
 */

import { CONTEXT_KEY } from "@atoms/atom-types";
import { DefaultAtoms, DefaultEntities, NotificationEntities } from "@atoms/atom-types";
import { NotificationAtoms } from "@atoms/notification-module/types";
import { Atoms } from "../enums/atoms";
import { Entities } from "../enums/entities";
import { UserState } from "@atoms/atom-types";

// Extended atom infos with default values
export const atomInfosExtended = {
  [Atoms.AdditionalArticleInfo]: {
    entityType: Entities.AdditionalArticle,
    currentSchemaVersion: 1,
    defaultValues: {
      "articleNumber": "",
      "deleted": false,
      "name": "",
      "purchasePrice": null,
      "unit": "Piece",
      "weight": null,
      "workUnits": 0,
    },
    findSortableFields: ["additionalArticleId", "articleNumber", "author", "date", "deleted", "id", "name", "purchasePrice", "unit", "weight", "workUnits"],
  },
  [Atoms.ImportProtocol]: {
    entityType: Entities.ImportProcess,
    findSortableFields: ["date", "id", "importProcessId", "source", "status"],
  },
  [Atoms.InstrumentInfo]: {
    entityType: Entities.Instrument,
    currentSchemaVersion: 2,
    defaultValues: {
      "availableExternally": false,
      "category": "Keyboard",
      "deleted": false,
      "depth": 0,
      "height": 0,
      "keyCount": null,
      "lookupKey": "",
      "manufacturer": "",
      "model": "",
      "productType": "keyboardcase",
      "width": 0,
    },
    findSortableFields: ["author", "availableExternally", "category", "date", "deleted", "depth", "height", "id", "instrumentId", "keyCount", "lookupKey", "manufacturer", "model", "productType", "width"],
  },
  [Atoms.OrderInfo]: {
    entityType: Entities.Order,
    findSortableFields: ["id", "orderId"],
  },
  [Atoms.OrderPositions]: {
    entityType: Entities.Order,
  },
  [Atoms.PositionInfo]: {
    entityType: Entities.Position,
    currentSchemaVersion: 3,
    defaultValues: {
      "additionalArticles": null,
      "amount": 1,
      "articleId": null,
      "claimee": null,
      "commodityGroup": "",
      "compartments": null,
      "createdAt": () => new Date(),
      "customer": "",
      "deleted": false,
      "description": "",
      "division": "",
      "importReport": null,
      "manualChanges": null,
      "manufacturer": "",
      "megaCaseInfo": null,
      "metaInfo": null,
      "model": "",
      "orderNumber": "",
      "price": null,
      "priceParameters": null,
      "reference": "",
      "requiredPresets": () => [],
      "source": "",
      "userDefinedOptions": null,
      "variant": "",
    },
    requireExplicitWritePermissionFields: ["createdAt", "source"],
    findSortableFields: ["additionalArticles", "amount", "articleId", "author", "claimee", "commodityGroup", "compartments", "createdAt", "customer", "date", "deleted", "description", "division", "id", "importReport", "manualChanges", "manufacturer", "megaCaseInfo", "metaInfo", "model", "orderNumber", "positionId", "price", "priceParameters", "reference", "requiredPresets", "source", "userDefinedOptions", "variant"],
  },
  [Atoms.PositionMeta]: {
    entityType: Entities.Position,
    defaultValues: {
      "previewImageUrl": null,
    },
    findSortableFields: ["id", "positionId"],
  },
  [Atoms.PresetInfo]: {
    entityType: Entities.Preset,
    currentSchemaVersion: 3,
    defaultValues: {
      "availableExternally": false,
      "category": "",
      "data": {},
      "deleted": false,
      "name": "",
      "nameEn": "",
      "productType": "",
      "tags": undefined,
    },
    requireExplicitWritePermissionFields: ["tags"],
    requireExplicitWritePermissionCustomPermissions: {
      "tags": "custom:ManageTaggedPresets",
    },
    findSortableFields: ["author", "availableExternally", "category", "data", "date", "deleted", "id", "name", "nameEn", "presetId", "productType", "tags"],
  },
  [Atoms.PresetList]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.PriceDataInfo]: {
    entityType: Entities.PriceData,
    defaultValues: {
      "countRivets": 0,
      "customerName": "",
      "description": "",
      "partCategory": "",
      "pricePurchase": 0,
      "unit": "Unknown",
      "weightGramms": 0,
      "workingTimeMinutes": 0,
    },
    findSortableFields: ["description", "id", "name", "partCategory", "priceDataId"],
  },
  [Atoms.PriceParameters]: {
    entityType: DefaultEntities.Global,
    collection: "set" as const,
    findSortableFields: ["key"],
  },
  [Atoms.RecentImports]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.UserOptionInfo]: {
    entityType: Entities.UserOption,
    currentSchemaVersion: 3,
    defaultValues: {
      "aliases": undefined,
      "availableExternally": false,
      "deleted": false,
      "description": "",
      "descriptionEn": "",
      "kind": "",
      "meshes": undefined,
      "name": "",
    },
    findSortableFields: ["aliases", "author", "availableExternally", "date", "deleted", "description", "descriptionEn", "id", "kind", "meshes", "name", "userOptionId"],
  },
  [Atoms.UserOptionsList]: {
    entityType: DefaultEntities.Global,
  },
  [DefaultAtoms.ApiTokens]: {
    entityType: DefaultEntities.User,
    requireExplicitReadPermission: true,
    collection: "set" as const,
    findSortableFields: ["key", "tokenHash", "userId"],
  },
  [DefaultAtoms.FrontendConfig]: {
    entityType: DefaultEntities.Global,
    collection: "set" as const,
    findSortableFields: ["key", "value"],
  },
  [DefaultAtoms.PersonalUserData]: {
    entityType: DefaultEntities.User,
    defaultValues: {
      "authProviderId": null,
      "emailVerified": false,
      "imageUrl": "",
      "isAdmin": false,
      "permissions": [],
      "serviceAccount": false,
      "state": UserState.Active,
    },
    requireExplicitWritePermissionFields: ["authProviderId", "emailVerified", "isAdmin", "serviceAccount", "state"],
    requireExplicitWritePermissionCustomPermissions: {
      "authProviderId": "custom:UpdateProtectedUserFields",
      "emailVerified": "custom:UpdateProtectedUserFields",
      "isAdmin": "custom:UpdateProtectedUserFields",
      "serviceAccount": "custom:UpdateProtectedUserFields",
      "state": "custom:UpdateProtectedUserFields",
    },
    findSortableFields: ["authProviderId", "displayName", "email", "emailVerified", "firstName", "id", "imageUrl", "isAdmin", "lastName", "permissions", "serviceAccount", "state", "userId"],
  },
  [NotificationAtoms.NotificationContent]: {
    entityType: NotificationEntities.Notification,
    defaultValues: {
      "actionLabel": null,
      "actionUrl": null,
      "createdAt": () => new Date(),
      "priority": "normal",
    },
    findSortableFields: ["id", "notificationContext", "notificationId", "notificationName", "notificationType"],
  },
  [NotificationAtoms.UserNotificationInbox]: {
    entityType: NotificationEntities.UserNotification,
    requireExplicitReadPermission: true,
    findSortableFields: ["createdAt", "deleted", "id", "notificationContext", "notificationId", "notificationName", "notificationType", "userId", "userNotificationId"],
  },
  [NotificationAtoms.UserNotificationInfo]: {
    entityType: NotificationEntities.UserNotification,
    defaultValues: {
      "createdAt": () => new Date(),
      "deleted": false,
      "deletedAt": null,
      "dismissable": true,
      "evictedAt": null,
      "keyed": false,
      "read": false,
      "readAt": null,
    },
    requireExplicitReadPermission: true,
    findSortableFields: ["deleted", "id", "notificationId", "userNotificationId"],
  },
};

export const entityInfos = {
  [DefaultEntities.Global]: {
    validContexts: [
      []
    ],
    pathTemplates: [
      `/`
    ],
    urlTemplate: "/",
  },
  [DefaultEntities.User]: {
    validContexts: [
      [CONTEXT_KEY(DefaultEntities.User)]
    ],
    pathTemplates: [
      `/User/<User>`
    ],
    urlTemplate: "/:user",
  },
  [Entities.AdditionalArticle]: {
    validContexts: [
      [CONTEXT_KEY(Entities.AdditionalArticle)]
    ],
    pathTemplates: [
      `/AdditionalArticle/<AdditionalArticle>`
    ],
    urlTemplate: "/:additionalArticle",
    findSortableFields: ["additionalArticleId", "additionalArticleInfoArticleNumber", "additionalArticleInfoAuthor", "additionalArticleInfoDate", "additionalArticleInfoDeleted", "additionalArticleInfoName", "additionalArticleInfoPurchasePrice", "additionalArticleInfoUnit", "additionalArticleInfoWeight", "additionalArticleInfoWorkUnits", "id"],
  },
  [Entities.ImportProcess]: {
    validContexts: [
      [CONTEXT_KEY(Entities.ImportProcess)]
    ],
    pathTemplates: [
      `/ImportProcess/<ImportProcess>`
    ],
    urlTemplate: "/:importProcess",
    findSortableFields: ["id", "importProcessId", "importProtocolDate", "importProtocolDuration", "importProtocolErrors", "importProtocolMessages", "importProtocolPositionsCreated", "importProtocolPositionsFetched", "importProtocolSource", "importProtocolStack", "importProtocolStatus", "importProtocolWarnings"],
  },
  [Entities.Instrument]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Instrument)]
    ],
    pathTemplates: [
      `/Instrument/<Instrument>`
    ],
    urlTemplate: "/:instrument",
    findSortableFields: ["id", "instrumentId", "instrumentInfoAuthor", "instrumentInfoAvailableExternally", "instrumentInfoCategory", "instrumentInfoDate", "instrumentInfoDeleted", "instrumentInfoDepth", "instrumentInfoHeight", "instrumentInfoKeyCount", "instrumentInfoLookupKey", "instrumentInfoManufacturer", "instrumentInfoModel", "instrumentInfoProductType", "instrumentInfoWidth"],
  },
  [Entities.Order]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Order)]
    ],
    pathTemplates: [
      `/Order/<Order>`
    ],
    urlTemplate: "/:order",
    findSortableFields: ["id", "orderId", "orderInfoImportDate", "orderInfoOrderDate", "orderInfoSource", "orderInfoSourceId"],
  },
  [Entities.Position]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Position)]
    ],
    pathTemplates: [
      `/Position/<Position>`
    ],
    urlTemplate: "/pos/:position",
    findSortableFields: ["id", "positionId", "positionInfoAdditionalArticles", "positionInfoAmount", "positionInfoArticleId", "positionInfoAuthor", "positionInfoClaimee", "positionInfoCommodityGroup", "positionInfoCompartments", "positionInfoCreatedAt", "positionInfoCustomer", "positionInfoDate", "positionInfoDeleted", "positionInfoDescription", "positionInfoDivision", "positionInfoImportReport", "positionInfoManualChanges", "positionInfoManufacturer", "positionInfoMegaCaseInfo", "positionInfoMetaInfo", "positionInfoModel", "positionInfoOrderNumber", "positionInfoPrice", "positionInfoPriceParameters", "positionInfoReference", "positionInfoRequiredPresets", "positionInfoSource", "positionInfoUserDefinedOptions", "positionInfoVariant", "positionMetaPreviewImageUrl"],
  },
  [Entities.Preset]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Preset)]
    ],
    pathTemplates: [
      `/Preset/<Preset>`
    ],
    urlTemplate: "/:preset",
    findSortableFields: ["id", "presetId", "presetInfoAuthor", "presetInfoAvailableExternally", "presetInfoCategory", "presetInfoData", "presetInfoDate", "presetInfoDeleted", "presetInfoName", "presetInfoNameEn", "presetInfoProductType", "presetInfoTags"],
  },
  [Entities.PriceData]: {
    validContexts: [
      [CONTEXT_KEY(Entities.PriceData)]
    ],
    pathTemplates: [
      `/PriceData/<PriceData>`
    ],
    urlTemplate: "/:priceData",
    findSortableFields: ["id", "priceDataId", "priceDataInfoCountRivets", "priceDataInfoCustomerName", "priceDataInfoDescription", "priceDataInfoName", "priceDataInfoPartCategory", "priceDataInfoPricePurchase", "priceDataInfoUnit", "priceDataInfoWeightGramms", "priceDataInfoWorkingTimeMinutes"],
  },
  [Entities.UserOption]: {
    validContexts: [
      [CONTEXT_KEY(Entities.UserOption)]
    ],
    pathTemplates: [
      `/UserOption/<UserOption>`
    ],
    urlTemplate: "/:userOption",
    findSortableFields: ["id", "userOptionId", "userOptionInfoAliases", "userOptionInfoAuthor", "userOptionInfoAvailableExternally", "userOptionInfoDate", "userOptionInfoDeleted", "userOptionInfoDescription", "userOptionInfoDescriptionEn", "userOptionInfoKind", "userOptionInfoMeshes", "userOptionInfoName"],
  },
  [NotificationEntities.Notification]: {
    validContexts: [
      [CONTEXT_KEY(NotificationEntities.Notification)]
    ],
    pathTemplates: [
      `/Notification/<Notification>`
    ],
    urlTemplate: "/:notification",
  },
  [NotificationEntities.UserNotification]: {
    validContexts: [
      [CONTEXT_KEY(DefaultEntities.User), CONTEXT_KEY(NotificationEntities.UserNotification)]
    ],
    pathTemplates: [
      `/User/<User>/UserNotification/<UserNotification>`
    ],
    urlTemplate: "/:user/:userNotification",
  },
};

export function getPathesForEntity<T extends keyof typeof entityInfos>(entity: T, name: string): string[] {
  const info = entityInfos[entity];
  return info?.pathTemplates.map((template: string) => `${template}/${name}`) ?? [];
}